"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseSearchType = exports.SearchTypes = exports.DefaultSearchType = void 0;
var SearchTypes = exports.SearchTypes = ['normal', 'new-price', 'new-listings', 'strict-new-listings', 'cross-promotion'];
var DefaultSearchType = exports.DefaultSearchType = 'normal';
var parseSearchType = exports.parseSearchType = function parseSearchType(value) {
  var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DefaultSearchType;
  if (!value) {
    return defaultValue;
  }
  if (SearchTypes.includes(value)) {
    return value;
  }
  return defaultValue;
};